import Widget, { IWidgetConsumer } from 'app/components/common/Widget';
import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { ZielErgebnisBalken, ZielErgebnisBalkenModel } from 'app/components/charts/ZielErgebnisBalken';
import React, { useEffect, useState } from 'react';
import { GPMAXYEAR } from 'app/stores/ui/berichte.ui.store';

export const AgenturEhSachbewertungWidget = observer((props: IWidgetConsumer) => {
	const { agenturUiStore } = useStore();
	const agt = agenturUiStore.current;

	const { agtProdUiStore } = useStore();
	const [model, setModel] = useState<ZielErgebnisBalkenModel>();

	useEffect(() => {
		if (agt) {
			agtProdUiStore.findByPlanKeyAndAgtId('sachbewertung', agt.agtId, GPMAXYEAR).then((res) => {
				if (res && res.posVal) {
					const ze = new ZielErgebnisBalkenModel(res.posVal.ziel, res.posVal.ergebnis);
					setModel(ze);
				}
			});
		}
	}, [agtProdUiStore, agt]);

	return (
		<>
			{model && agt && !agt.isPro3 && (
				<Widget title={'EH Sachbewertung'} widgetId={props.widgetKey}>
					<>
						<ZielErgebnisBalken model={model} />
					</>
				</Widget>
			)}
		</>
	);
});
